import store from "../store"

const hasPermission = (data)=>{
    let result = store.getters.perms.includes(data)

    return result
}


export default{
  hasPermission
}